/**
 * =============================================================================
 * SPEQ55 RFP Pro - Model Configuration API Client
 * =============================================================================
 *
 * API client functions for managing AI model configuration.
 *
 * @module api/modelConfig
 * @author SPEQ55
 */

import api from './client.js';

/**
 * Get current model configuration and available models
 */
export async function getModelConfig() {
  const response = await api.get('/models');
  return response.data;
}

/**
 * Update model for a slot (default or extended)
 */
export async function updateModelSlot(slot, modelName) {
  const response = await api.put(`/models/${slot}`, { modelName });
  return response.data;
}

/**
 * Get model configuration audit history
 */
export async function getModelAuditHistory(limit = 50) {
  const response = await api.get(`/models/audit?limit=${limit}`);
  return response.data;
}

export default {
  getModelConfig,
  updateModelSlot,
  getModelAuditHistory,
};
